import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../services/LogoutFunction";

export const getFormJoinApi = createAsyncThunk(
  "form/Join-get",
  async () => {

    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;

    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/contact_join/get_join_us`,
      {
        method: "GET",
        headers: {
          Authorization:
            `Bearer ${tokenData}`,
        },
      }
    ).then(response => response.json()).then(result => {
        return result
    }).catch(error =>{
        return error;
    })
    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const GetFormJoinSlicer = createSlice({
  name: "form/contact-get",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getFormJoinApi.pending,state =>{
        state.loading = true;
        state.data = null;
        state.error = null;
    });
    builder.addCase(getFormJoinApi.fulfilled,(state,action) =>{
      state.loading = false;
      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      }else if (action.payload.message === "Data sent successfully") {
            state.data = action.payload;
            state.error = null;
        }
       else{
        
            state.data = null;
            state.error = action.payload.message;
            formatError( state.error);
        }


    });
    builder.addCase(getFormJoinApi.rejected,(state,action) =>{
        state.loading = false;
            state.lessons = null;
            state.error = action.payload.message;
            formatError(state.error);

    });
  },
});


export default GetFormJoinSlicer.reducer;